import { t } from "i18next";
import { Container, Row, Col } from "react-bootstrap";
// import { Link } from "react-router-dom";

export default function Rules(){

    // const navigate = 

    return (
        <Container fluid as='main' className="rules">
            <Row>
                <Col className="text-sm-center">
                    <h1>{t('rules.title')}</h1>
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col dangerouslySetInnerHTML={{__html:t('rules.body')}}>
                </Col>
            </Row>
        </Container>
    );
}